import React, {createContext, useContext, useEffect, useState} from "react";
import LoadingIndicator from "canvas-core-react/lib/LoadingIndicator";
import handleErrorComponent from "../utils/errors/handle-error-component";

const AppContext = createContext(null);

const contextDefaultValue = {
    subjectId: null,
    subjectData: {
        subjectToken: "",
        document_number: "",
        rut: "",
        name: "",
        email: "",
    },
    agentSubject: null,
    insurance: "",
    previredToken: "",
    selectedPlan: null,
    givenPlan: null,
    filteredPlan: {},
    smsToken: null,
    equifaxToken: null,
    error: false,
    ErrorComponent: null,
    loading: false,
    clientStep: "stepRut",
    isValidEmail: false,
    isValidPhone: false,
    isValidBiometric: false,
    validationCheck: false,
    documentRequestId: null,
    contact: {},
    receiptData: {},
    productsData: [],
    checkedStep: {
        stepRut: false,
        stepContactability: false,
        stepProducts: false,
        planContracts: false,
        stepSelectValidationOptions: false
    }
};

const AppProvider = ({children, initValue = contextDefaultValue}) => {
    const [state, setState] = useState(initValue);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [state.equifaxToken, state.clientStep]);

    const displayError = (error, callBackFn, component) => {
        const Comp = component || handleErrorComponent(error, callBackFn);
        changeItem({error: true, ErrorComponent: Comp});
    };

    const changeItem = (item) => {
        setState((prevState) => ({...prevState, ...item}));
    };

    const {loading, error, ErrorComponent} = state;

    return (
        <AppContext.Provider
            value={{
                state,
                changeItem,
                displayError,
            }}
        >
            {children}
            {error && ErrorComponent}
            {loading && (
                <div className="loading__container">
                    <LoadingIndicator size="large"/>
                </div>
            )}
        </AppContext.Provider>
    );
};

export default AppProvider;
export const useAppContext = () => useContext(AppContext);
export {AppContext};

